import { inject, Injectable } from "@angular/core";
import { NzModalRef } from "ng-zorro-antd/modal";
import { ModalService } from "./modal.service";
import { CoreFileViewerModalComponent } from "../components/core-file-viewer-modal/core-file-viewer-modal.component";
import { FileViewerUtils } from "../utils/file-viewer.util";

export interface OpenFileViewerParams {
  url: string;
  fileName: string;
  fileType?: string | null;
  /** Optional "TYPE · size" line shown under the filename in the viewer header (mirrors the card's secondary line). */
  secondaryLine?: string;
}

@Injectable({
  providedIn: "root",
})
export class FileViewerService {
  private readonly modalService = inject(ModalService);

  /**
   * Opens the shared file viewer modal for PDFs/images; falls back to onDownload
   * for any other file type, per HAN-362 (viewer only supports PDF/image inline).
   * Returns the modal ref (e.g. so callers can revoke a blob URL on afterClose), or
   * undefined when the fallback download was used instead.
   */
  open(params: OpenFileViewerParams, onDownload: () => void): NzModalRef | undefined {
    const kind = FileViewerUtils.getFileKind(params.fileName || params.url, params.fileType);

    if (kind === "other") {
      onDownload();
      return undefined;
    }

    return this.modalService.create({
      nzContent: CoreFileViewerModalComponent,
      nzData: { ...params, onDownload },
      nzMaskClosable: true,
      nzWidth: 900,
      nzStyle: {
        margin: 0,
        maxWidth: "95vw",
        maxHeight: "90vh",
        padding: 0,
      },
    });
  }
}
